/* ============================================================
   THEME.JS — Kunvarani Theme
   Global utilities — cart, navigation, product interactions
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Cart: update item count badge from Shopify AJAX API
     ---------------------------------------------------------- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.cart-count');
        if (!badge) return;
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  /* ----------------------------------------------------------
     Product form: AJAX add to cart
     ---------------------------------------------------------- */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = productForm.querySelector('[type="submit"]');

      if (submitBtn) {
        submitBtn.textContent = 'Adding…';
        submitBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          updateCartCount();
          if (window.fbq) {
            fbq('track', 'AddToCart', {
              content_ids: [String(data.variant_id)],
              content_type: 'product_variant',
              value: data.price / 100,
              currency: 'INR'
            });
          }
          if (submitBtn) {
            submitBtn.textContent = 'Added';
            setTimeout(function () {
              submitBtn.textContent = 'Add to cart';
              submitBtn.disabled = false;
            }, 1500);
          }
          productForm.dispatchEvent(new Event('cartUpdated'));
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.textContent = 'Add to cart';
            submitBtn.disabled = false;
          }
        });
    });
  }

  /* ----------------------------------------------------------
     Initialise cart count on load
     ---------------------------------------------------------- */
  updateCartCount();

  /* ----------------------------------------------------------
     Fade-up scroll animations
     ---------------------------------------------------------- */
  (function () {
    var targets = document.querySelectorAll(
      '.product-card, .category-card, .new-arrivals__heading, ' +
      '.categories__heading, .brand-story__heading, .dm-cta__heading, ' +
      '.k-reserve__item, .about-page__body p, .section-divider, .care-guide__item'
    );

    if (!targets.length || !window.IntersectionObserver) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    targets.forEach(function (el) { el.classList.add('fade-up'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    targets.forEach(function (el) { observer.observe(el); });
  })();

  /* ----------------------------------------------------------
     Cart drawer
     ---------------------------------------------------------- */
  (function () {
    var drawer  = document.getElementById('cart-drawer');
    var overlay = document.querySelector('.cart-overlay');
    var body    = document.getElementById('cart-drawer-body');
    var footer  = document.getElementById('cart-drawer-footer');
    var subtotal = document.getElementById('cart-drawer-subtotal');
    var shipNote = document.getElementById('cart-drawer-shipnote');

    if (!drawer) return;

    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    function renderCart(cart) {
      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        if (footer) footer.hidden = true;
        return;
      }

      var items = cart.items.map(function (item) {
        var image = item.image
          ? '<img class="cart-item__image" src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
          : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
          : '';
        return '<li class="cart-item">'
          + image
          + '<div class="cart-item__details">'
          + '<p class="cart-item__title">' + item.product_title + '</p>'
          + variant
          + '<p class="cart-item__price">Qty ' + item.quantity + ' &nbsp;·&nbsp; ' + formatMoney(item.line_price) + '</p>'
          + '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>'
          + '</div>'
          + '</li>';
      }).join('');

      body.innerHTML = '<ul class="cart-drawer__items">' + items + '</ul>';
      if (footer) footer.hidden = false;
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      // Real total including shipping/COD fee, shown live so the number at
      // checkout is never a surprise. Same tiers as sections/main-cart.liquid:
      // prepaid free >= Rs2,000 (else Rs149); COD free >= Rs4,000 (else Rs200).
      var totalOnlineEl = document.getElementById('cart-drawer-total-online');
      var totalCodEl = document.getElementById('cart-drawer-total-cod');
      if (totalOnlineEl && totalCodEl) {
        var sub = cart.total_price;
        var onlineShip = sub >= 200000 ? 0 : 14900;
        var codShip = sub >= 400000 ? 0 : 20000;
        totalOnlineEl.textContent = formatMoney(sub + onlineShip);
        totalCodEl.textContent = formatMoney(sub + codShip);
      }

      // Ship note: ALWAYS names both rates (prepaid + COD), same three tiers
      // as sections/main-cart.liquid, computed live off the real cart total.
      // Never a single generic line — a shopper close to a threshold needs to
      // see the exact rupee gap to it, for both payment methods, every time.
      if (shipNote) {
        var rs = cart.total_price / 100;
        if (rs >= 4000) {
          shipNote.textContent = 'Shipping is on us, whether you pay online or on delivery.';
        } else if (rs >= 2000) {
          var toCodFree = Math.ceil(4000 - rs);
          shipNote.textContent = 'Shipping is on us when you pay online. Cash on delivery is \u20B9200 (\u20B9' + toCodFree + ' more and that\'s free too).';
        } else {
          var toFree = Math.ceil(2000 - rs);
          shipNote.textContent = 'Shipping is \u20B9149 when you pay online, \u20B9200 on cash on delivery. \u20B9' + toFree + ' more and the online rate is on us.';
        }
      }

      body.querySelectorAll('.cart-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              renderCart(cart);
              updateCartCount();
            });
        });
      });
    }

    function fetchAndOpen() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          openDrawer();
        });
    }

    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', fetchAndOpen);
    });

    document.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Open drawer whenever any add-to-cart completes (product page or quick view)
    document.addEventListener('cart:added', fetchAndOpen);

    // Re-open drawer after add to cart instead of navigating away
    if (productForm) {
      productForm.addEventListener('cartUpdated', function () {
        document.dispatchEvent(new CustomEvent('cart:added'));
      });
    }
  })();

  // Story modal — once per session, after the FIRST successful add-to-cart.
  // Never blocks: fires ~700ms after the cart drawer opens so it doesn't
  // fight the drawer's own animation, thumbnail only (video has preload=none
  // in the markup, no autoplay), closable via X / backdrop / Escape at any
  // time, and gone for the rest of the session once shown or dismissed.
  (function () {
    var modal = document.getElementById('story-modal');
    var overlay = document.querySelector('.story-modal-overlay');
    if (!modal) return;

    var SEEN_KEY = 'kv_story_modal_seen';

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
    }

    modal.querySelectorAll('[data-story-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    if (overlay) overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    document.addEventListener('cart:added', function () {
      var seen = false;
      try { seen = sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) {}
      if (seen) return;
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      setTimeout(openModal, 700);
    });
  })();

  /* ----------------------------------------------------------
     Search bar toggle
     ---------------------------------------------------------- */
  (function () {
    var toggle  = document.querySelector('.header-search-toggle');
    var bar     = document.getElementById('search-bar');
    var input   = document.getElementById('search-bar-input');
    var closeBtn = document.querySelector('[data-search-close]');
    if (!toggle || !bar) return;

    function openSearch() {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }

    function closeSearch() {
      bar.hidden = true;
      bar.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      bar.hidden ? openSearch() : closeSearch();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !bar.hidden) closeSearch();
    });
  })();

  /* ----------------------------------------------------------
     Quick view modal
     ---------------------------------------------------------- */
  (function () {
    var modal = document.getElementById('quick-view-modal');
    var modalBody = document.getElementById('quick-view-body');
    if (!modal) return;

    // Cache fetched product data so re-opens are instant
    var qvCache = {};

    // Prefetch product JSON on hover (desktop) and first touch (mobile)
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      var url = btn.dataset.productUrl;
      if (!url || qvCache[url]) return;
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        qvCache[url] = data;
        (data.images || []).forEach(function (src) { var i = new Image(); i.src = shopifyImg(src, 600); });
      }).catch(function () {});
    });

    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest('.product-card');
      if (!card) return;
      var btn = card.querySelector('[data-quick-view]');
      if (!btn) return;
      var url = btn.dataset.productUrl;
      if (!url || qvCache[url]) return;
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        qvCache[url] = data;
        (data.images || []).forEach(function (src) { var i = new Image(); i.src = shopifyImg(src, 600); });
      }).catch(function () {});
    }, { passive: true });

    // Resize a Shopify CDN image URL to a given width
    function shopifyImg(src, width) {
      if (!src) return src;
      return src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + width + 'x$1$3');
    }

    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
    }

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderQuickView(product) {
      var firstVariant = product.variants[0];
      var images = product.images || [];
      var currentIndex = 0;

      function buildImageSlider() {
        if (images.length === 0) return '';
        var slides = images.map(function (src) {
          var sized = shopifyImg(src, 600);
          return '<div class="qv-slide"><img src="' + sized + '" alt="' + product.title + '" loading="eager"></div>';
        }).join('');
        var arrows = images.length > 1
          ? '<button class="qv-prev" aria-label="Previous image">&#8592;</button>'
          + '<button class="qv-next" aria-label="Next image">&#8594;</button>'
          : '';
        return '<div class="quick-view__image-wrap">'
          + '<div class="qv-track" id="qv-track">' + slides + '</div>'
          + arrows
          + '</div>';
      }

      var variantOptions = '';
      if (product.variants.length > 1) {
        variantOptions = '<div class="quick-view__variants">'
          + '<label for="qv-variant">Select option</label>'
          + '<select id="qv-variant">'
          + product.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>'
              + v.title + (v.available ? '' : ' — Sold out') + '</option>';
          }).join('')
          + '</select>'
          + '</div>';
      }

      var wlImg = product.images && product.images[0] ? shopifyImg(product.images[0], 600) : '';
      var wlBtn = '<button class="wishlist-btn qv-wishlist-btn" data-wishlist-btn'
        + ' data-product-id="' + product.id + '"'
        + ' data-product-handle="' + product.handle + '"'
        + ' data-product-title="' + product.title.replace(/"/g, '&quot;') + '"'
        + ' data-product-image="' + wlImg + '"'
        + ' data-product-price="' + firstVariant.price + '"'
        + ' data-product-url="' + product.url + '"'
        + ' aria-label="Save to wishlist">'
        + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + ' Save</button>';

      modalBody.innerHTML = buildImageSlider()
        + '<div class="quick-view__details">'
        + '<h2 class="quick-view__title">' + product.title + '</h2>'
        + '<p class="quick-view__price">' + formatMoney(firstVariant.price) + '</p>'
        + variantOptions
        + '<form class="quick-view__add" id="quick-view-form">'
        + '<input type="hidden" name="id" value="' + firstVariant.id + '">'
        + '<button type="submit" class="btn btn--primary" style="width:100%">Add to cart</button>'
        + '</form>'
        + '<a href="' + product.url + '" class="quick-view__view-full">View full details</a>'
        + wlBtn
        + '</div>';

      if (window.Wishlist) window.Wishlist.init();

      // Preload secondary images so they're ready before the user swipes
      if (images.length > 1) {
        images.slice(1).forEach(function (src) {
          var img = new Image();
          img.src = shopifyImg(src, 600);
        });
      }

      // Image slider
      if (images.length > 1) {
        var track  = document.getElementById('qv-track');
        var prevBtn = modalBody.querySelector('.qv-prev');
        var nextBtn = modalBody.querySelector('.qv-next');

        function showImage(index) {
          currentIndex = (index + images.length) % images.length;
          if (track) track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

        // Touch swipe support
        if (track) {
          var touchStartX = 0;
          track.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].clientX;
          }, { passive: true });
          track.addEventListener('touchend', function (e) {
            var delta = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(delta) > 40) showImage(delta < 0 ? currentIndex + 1 : currentIndex - 1);
          }, { passive: true });
        }
      }

      var qvSelect = modalBody.querySelector('#qv-variant');
      var qvInput  = modalBody.querySelector('[name="id"]');
      if (qvSelect && qvInput) {
        qvSelect.addEventListener('change', function () {
          qvInput.value = qvSelect.value;
        });
      }

      var qvForm = document.getElementById('quick-view-form');
      if (qvForm) {
        qvForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = qvForm.querySelector('[type="submit"]');
          btn.textContent = 'Adding…';
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(qvForm)
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              updateCartCount();
              // Deliberately no fbq AddToCart here. A one-tap add from the quick-view
              // overlay is too cheap a signal to optimise ads against; firing it taught
              // Meta to find quick-add tappers rather than buyers. The product-page
              // handler above remains the single source of AddToCart.
              btn.textContent = 'Added';
              setTimeout(function () {
                closeModal();
                btn.textContent = 'Add to cart';
                btn.disabled = false;
                document.dispatchEvent(new CustomEvent('cart:added'));
              }, 800);
            })
            .catch(function () {
              btn.textContent = 'Add to cart';
              btn.disabled = false;
            });
        });
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      var url = btn.dataset.productUrl;
      if (!url) return;
      openModal();
      if (qvCache[url]) {
        renderQuickView(qvCache[url]);
        return;
      }
      modalBody.innerHTML = '<p style="text-align:center;padding:2rem;opacity:0.5">Loading…</p>';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          qvCache[url] = data;
          renderQuickView(data);
        });
    });

    document.querySelectorAll('[data-quick-view-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  })();

  /* ----------------------------------------------------------
     Mobile nav accordion (Everyday Wear / Occasion Wear sub-links)
     ---------------------------------------------------------- */
  (function () {
    document.querySelectorAll('.nav-accordion-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = this.closest('.nav-item--dropdown');
        if (!item) return;
        var dropdown = item.querySelector('.nav-dropdown');
        if (!dropdown) return;
        var isOpen = dropdown.classList.toggle('is-open');
        this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  })();

  /* ----------------------------------------------------------
     Back to top button
     ---------------------------------------------------------- */
  (function () {
    var btn = document.querySelector('.back-to-top');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) {
        btn.removeAttribute('hidden');
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
        btn.setAttribute('hidden', '');
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

})();
